import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ImgCompletedNarrative from 'assets/images/narratives/narrative_completed.svg';
import ImgBgCompletedNarrative from 'assets/images/narratives/bg_narrative_completed.svg';
import OngoingActivity from 'components/OngoingActivity';
import ConfirmModal from 'components/ConfirmModal';
import LoadingComponent from 'components/LoadingComponent';
import apiFetch from 'utils/apiFetch';
import { FinalStepWrapper } from './styles';

function FinalStep(props) {
  const {
    literals, id, history, narrativesList,
  } = props;

  const [showConfirmReset, setShowConfirmReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showResetModal = () => {
    setShowConfirmReset(true);
  };

  const hideResetModal = () => {
    setShowConfirmReset(false);
  };

  const avoidDragMovement = (event) => {
    event.stopPropagation();
  };

  const resetNarrative = () => {
    const endPoint = `narrative/${id}/reset`;
    setIsLoading(true);
    hideResetModal();

    apiFetch('POST', { endPoint })
      .then(() => {
        history.push('/');
        history.push(`/narratives/${id}`);
      });
  };

  const goToHall = () => {
    history.push(`/calls/${id}/hall`);
  };

  const printResetConfirm = () => {
    if (!showConfirmReset) {
      return null;
    }

    return (
      <ConfirmModal
        onClose={hideResetModal}
        onAccept={resetNarrative}
        open
        confirmText={literals.resetNarrative}
      />
    );
  };

  if (isLoading) {
    return (<LoadingComponent colorAnimation='#ffffff' />);
  }

  const isPreEvent = _.findIndex(narrativesList, { id, type: { id: 21227760 } }) >= 0;

  return (
    <React.Fragment>
      {printResetConfirm()}
      <FinalStepWrapper>
        <div className='images'>
          <img src={ImgBgCompletedNarrative} alt='' className='bg_completed_narrative' />
          <img src={ImgCompletedNarrative} alt='' className='img_completed_narrative' />
        </div>
        <div className='title' dangerouslySetInnerHTML={{ __html: literals.completedNarrative }} />
        <div className='buttons'>
          <button className='primary' onClick={showResetModal}>{literals.reset}</button>
          {isPreEvent ? (
            <button className='secondary' onClick={goToHall}>{literals.goToHall}</button>
          ) : null}
        </div>
        <div className='ongoing_title' dangerouslySetInnerHTML={{ __html: literals.joinOtherImpactObjectives }} />
        <div onMouseDown={avoidDragMovement}>
          <OngoingActivity />
        </div>
      </FinalStepWrapper>
    </React.Fragment>
  );
}

FinalStep.propTypes = {
  literals: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  narrativesList: PropTypes.array.isRequired,
};

export default FinalStep;



// WEBPACK FOOTER //
// ./src/components/Steps/FinalStep/components/FinalStep.jsx